import { IonAlert, IonContent, IonFab, IonFabButton, IonIcon, IonPage, useIonAlert } from '@ionic/react';
import { useHistory } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { useEffect, useState } from 'react';
import { _SMALL_SCREEN_WIDTH, _bulkImportPage, _cachedLocalAutoL2image, _cardSizeMultiplier, _clipboardCards, _defaultCardSize, _dict, _freeCards, _lang, _parentMode, _pathSeparator, _pathSeparatorPlaceholder, _rootName, _userUniqueId } from '../components/constants';
import { gitBranchOutline } from 'ionicons/icons';
import { goToPayment } from '../components/payments';
import BulkImport from '../components/BulkImport';
import { useUIStore } from '../components/stateManagement/UIZustand';
import ChoiceDialog from '../components/dialogs/ChoiceDialog';
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import { useUserStore } from '../components/stateManagement/userZustand';
import { useTreeStore } from '../components/stateManagement/treeZustand';
import ShareModal from '../components/dialogs/ShareModal';
import { logMe } from '../foo/user';
import './Page.css';
import { useURLStore } from '../components/stateManagement/URLZustand';
import CommonHeader from '../components/CommonHeader';
import { nodesCorrection } from '../foo/tree';
import ArtistComponent from '../components/artist/Artistic';
import GridMainComponent from '../components/grid/GridMainComponent';
import SavedArtComponent from '../components/artist/SavedArtComponent';
import { useArtStore } from '../components/stateManagement/artZustand';
import Grid from '../components/Grid';



const Page: React.FC = () => {
  const {
    setIsChoiceDialogOpen,
    isShareModalOpen,
    
  } = useUIStore();
  
  const { isParentMode, lang  } = useGlobalStore();

  const { nodesCount, updateFreeNodes, resetSnapshot, nodes, setNodes } = useTreeStore();
  const { userUniqueId, isSubscribed} = useUserStore();
  
  const { selectedLabels, resetSelectedLabels, isArtistMode, setIsArtistMode } = useUIStore();
  const [ currentLayerIndex, setCurrentLayerIndex ] = useState<string | number | null>(null);
  const { path2art } = useArtStore();
  
  const [ presentAlert ] = useIonAlert();
  const [ showAddButton, setShowAddButton ] = useState(true);
  const history = useHistory();

  const { URLVars, getURLTo, visibleLabels } = useURLStore();

  
  useEffect(() => {
    updateFreeNodes();
  }, []);

  useEffect(() => {
    if(isParentMode === true){
      resetSelectedLabels();
      nodesCorrection(nodes, setNodes, URLVars.nodePath!); 
    }
    resetSnapshot();
  }, [URLVars.nodePath, isParentMode]);
  
  if(URLVars.nodePath === undefined){return <></>}

  if(isArtistMode === true){
    if(currentLayerIndex !== null){
      return <ArtistComponent layerIndex={currentLayerIndex}
      setCurrentLayerIndex={setCurrentLayerIndex} />;
    }else if(path2art === undefined || path2art === null 
      || path2art[URLVars.nodePath!] === undefined || path2art[URLVars.nodePath!] === null
      || Object.keys(path2art[URLVars.nodePath!]).length === 0){
        return <ArtistComponent
        layerIndex={_dict.newLayout[lang] + " (" + new Date().toLocaleString() + ")"}
        setCurrentLayerIndex={setCurrentLayerIndex}
        />;
    }
    return <SavedArtComponent
    
    isOpen={true}
    onClose={()=>{ setCurrentLayerIndex(null); setIsArtistMode(false); }}
    onConfirm={(layerIndex:string|number) => { 
      setCurrentLayerIndex(layerIndex);
    }}
    />//return <ArtistComponent layerIndex={0} />;

  } 

  const FreeQuotaAlert = () => presentAlert({
    header: _dict.freeQuotaHeader[lang],
    message: _dict.freeQuotaMsg[lang],
    buttons: [{
      text: _dict.freeQuotaPremiumBtnText[lang],
      handler: async () => { logMe("click_premium",{from:"freeQuotaAlert"}); goToPayment(userUniqueId) }
    }]
  });


  const handleConfirmChoice = () => {
    setIsChoiceDialogOpen(false);
    if(isSubscribed === false && _freeCards <= nodesCount){
      FreeQuotaAlert();
      return;
    }
    history.push(getURLTo().bulkImport());
  }
  
  
  
  const addButton = <>
  <IonFab vertical="bottom" horizontal="center">
    <IonFabButton className="custom-fab-button"
    onClick={() => {logMe("click_add",{});setIsChoiceDialogOpen(true)}}>
      <IonIcon icon={gitBranchOutline} size='large' />
    </IonFabButton>
  </IonFab>
  <ChoiceDialog
  lang={lang}
  onConfirm={() => handleConfirmChoice()}
  onClose={() => setIsChoiceDialogOpen(false)} />
  </>
  

  

  
  /*const talkIcon = <button onClick={() => history.push(homePage)}
  style={{ backgroundColor: '#007ea7', color: 'white', fontSize: '24px', padding: '10px 20px', borderRadius: '10px', marginRight:"1px" }}>
    <IonIcon icon={chatbubbleEllipses} />
  </button>*/



  // Paste Button if clipboard cards array is not empty, otherwise Share Button
  
  //REF-3


  return (
    <IonPage >
      
      <CommonHeader />
      
      <IonContent fullscreen>
        
      { URLVars.section === "bulkImport" ? <BulkImport /> : null} 
      { URLVars.section !== "quiz" && URLVars.section !== "bulkImport" ? <ExploreContainer mainContent={<Grid />}  /> : null}
      { URLVars.section === "talk" && isParentMode === true && showAddButton && URLVars.nodePath !== "help" ? addButton : null}
      </IonContent>
      
      
      { 
        isShareModalOpen && isParentMode && Object.keys(selectedLabels).length > 0 ? <ShareModal data={Object.keys(selectedLabels).join(_pathSeparator)} /> :
        isShareModalOpen && isParentMode && visibleLabels && visibleLabels.length > 0 && <ShareModal data={visibleLabels.join(_pathSeparator)} />
      }
      { /*isSubscribed !== true && <AdsPage />*/}
      
    </IonPage>
  );


};



export default Page;